<template>
  <div id="app">
    <keep-alive>
      <!-- 如果当前打开页面的路由中 keepAlive: true （开启了缓存时） -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 如果当前打开页面的路由中 没有 或者为 keepAlive: false （关闭缓存时[默认就是false]） -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  methods: {
    bodyScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      document.cookie = `scroll=${scrollTop}`;
    },
    scrollback() {
      const scroll = this.GetCookie("scroll");
      if (scroll != null) {
        document.body.scrollTop = scroll;
      }
    },
    GetCookie(sName) {
      const aCookie = document.cookie.split(";");
      // console.log(aCookie);
      for (let i = 0; i < aCookie.length; i++) {
        const aCrumb = aCookie[i].split("=");
        if (sName == aCrumb[0]) {
          return aCrumb[1];
        }
      }
      return null;
    },
  },
  mounted() {
    // this.$i18n.locale='en'
    this.$nextTick(() => {
      window.addEventListener("scroll", this.bodyScroll, true);
      window.addEventListener("load", this.scrollback, true);
    });
  },
};
</script>
<style lang="less">
html,
body {
   background: var(--fill-1);
  // filter: invert(1) hue-rotate(180deg);
  // background-color: #00101F;
  background: #000000;
  color: #fff;
  margin: 0;
  padding: 0;
  width: 100%;
}
#app{
  width: 100%;
}
@media (prefers-color-scheme: dark) {
  body {
    background: #000000;
    color: #dcb;
    outline: 5px dashed #000;
  }
}
</style>
